import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';

type Archive = {
  icon: string;
  name: string;
  desc: string;
  count: number;
  caseId: string;
};

const archives: Archive[] = [
  {
    icon: 'ri-file-paper-2-line',
    name: '经纪解约',
    desc: '账号归属、分成条款与解约声明的拉扯，往往需要合同证据才能看清。',
    count: 6,
    caseId: 'mcn-contract-split',
  },
  {
    icon: 'ri-live-line',
    name: '直播带货',
    desc: '从“全网最低”到机制价，价格话术与实际成本之间的差距最容易被放大。',
    count: 11,
    caseId: 'live-sell-price',
  },
  {
    icon: 'ri-copyright-line',
    name: '内容版权',
    desc: '选题重合、脚本相似与洗稿争议，界定边界需要的往往不止一张对比图。',
    count: 5,
    caseId: 'copy-script',
  },
  {
    icon: 'ri-heart-3-line',
    name: '公益争议',
    desc: '善款去向与账目公开，透明是最有效的回应方式。',
    count: 4,
    caseId: 'pet-charity',
  },
  {
    icon: 'ri-price-tag-3-line',
    name: '品牌联动',
    desc: '联名翻车、图案相似与连夜下架，品牌与创作者各自的责任需要厘清。',
    count: 7,
    caseId: 'brand-collab-fail',
  },
  {
    icon: 'ri-movie-2-line',
    name: '剧情炒作',
    desc: '官宣、偶遇与剧本疑云，情感内容背后的机构运作最容易被忽略。',
    count: 9,
    caseId: 'fake-romance-script',
  },
];

const ArchiveSection = () => (
  <section id="archive" className="scroll-mt-24 border-b border-background-200 bg-background-50">
    <div className="layout-shell py-12 md:py-16">
      <SectionHeading
        eyebrow="Reversal Archive"
        title="反转档案"
        desc="按事件类型归档，每个分类都标注了已完成追踪的案例数量，方便你顺着线索往下看。"
      />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {archives.map((a, index) => (
          <Link
            key={a.name}
            to={`/case/${a.caseId}`}
            className={`group flex flex-col rounded-lg border p-5 transition-colors hover:border-primary-300 ${
              index === 0 ? 'border-accent-200 bg-accent-50' : 'border-background-300/70 bg-background-100'
            }`}
          >
            <div className="flex items-start justify-between">
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                  index === 0 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                <i className={`${a.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="font-heading text-2xl font-bold text-foreground-300">{String(a.count).padStart(2, '0')}</span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
              {a.name}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-primary-700">
              查看代表案例
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ArchiveSection;